import ContentTitle from "../../../components/ui/ContentTitle";
import { Tabs, TabsProps, message } from "antd";
import { Colors } from "../../../constants/Colors";
import { useState, useEffect } from "react";
import { Dispatch, SetStateAction } from "react";
import { ServiceTypes } from "../../../types/types";
import VideoTab from "./VideoTab";
import TagTab from "./TagTab";
import { useReactiveVar } from "@apollo/client";
import { VideoDataType, TagDataType } from "./types";
import { useGetUserProgramsByServiceQuery } from "../../../graphql/operations/get-user-program-by-service";
import { useGetVideoAndTagListQuery } from "../../../graphql/operations/trialMode/testimonial/get-video-and-tag-list";
import { renderDecodedId } from "../../../utils/renderDecodedId";
import { renderAntDMessageConfig } from "../../../utils/renderAntDMessageConfig";
import { __currentUser__ } from "../../../graphql/policies";
import Spinner from "../../../components/layout/spinner/Spinner";
import NoPermission from "../../../components/others/NoPermission";

interface TrialModeServiceTemplateProps {
    setSelectedService: Dispatch<SetStateAction<ServiceTypes>>;
    setSelectSubItem: Dispatch<SetStateAction<string | undefined>>;
    category: string;
}

const TrialModeServiceTemplate = ({
    setSelectedService,
    setSelectSubItem,
    category,
}: TrialModeServiceTemplateProps) => {
    const [loading, setLoading] = useState(false);
    const [market, setMarket] = useState("");
    const [videos, setVideos] = useState<VideoDataType[]>([]);
    const [tags, setTags] = useState<TagDataType[]>([]);
    const categoryList = [
        { title: "Testimonial", value: "trial-testimonial" },
    ];
    const currentUser = useReactiveVar(__currentUser__);
    const {
        data: userPrograms,
        loading: userProgramsLoading,
        error: userProgramsError,
    } = useGetUserProgramsByServiceQuery({
        variables: {
            userId: parseInt(renderDecodedId(currentUser?.id)),
            serviceId: 8,
        },
    });

    const { data, loading: videoLoading, refetch,
    } = useGetVideoAndTagListQuery({
        variables: {
            market: market,
        },
    });
    

    useEffect(() => {
        setVideos(data?.testimonialList ?? []);
        setTags(data?.testimonialTagList ?? []);
    }, [data]);

    useEffect(() => {
        if (currentUser?.afUserMarkets && currentUser?.afUserMarkets[0]?.market) {
            if (currentUser?.afUserMarkets.length === 1) {
                setMarket(currentUser?.afUserMarkets[0]?.market);
            } else {
                setMarket("KR");
            }
        }
    }, [currentUser]);

    useEffect(() => {
        setSelectedService(ServiceTypes.TRIAL_MODE);
        setSelectSubItem(categoryList.find((v) => v.value === category)?.title);
    }, []);

    const items: TabsProps["items"] = [
        {
            key: "1",
            label: "Video",
            children: (
                <VideoTab
                    category={category}
                    tags={tags}
                    videos={videos}
                    setVideos={setVideos}
                    market={market}
                    setMarket={setMarket}
                    currentUser={currentUser}
                    refetch={refetch}
                    setLoading={setLoading}
                />
            ),
        },
        {
            key: "2",
            label: "Tag",
            children: (
                <TagTab
                    category={category}
                    tags={tags}
                    setTags={setTags}
                    videos={videos}
                    market={market}
                    setMarket={setMarket}
                    currentUser={currentUser}
                    refetch={refetch}
                />
            ),
        },
    ];
    if (loading || videoLoading) {
        return <Spinner />;
    }
    if (userProgramsError) {
        message.error(
            renderAntDMessageConfig(
                "Something went wrong. Please contact your system administrator."
            )
        );
    }

    if (userProgramsLoading) {
        return <Spinner />;
    }
    if (
        userPrograms &&
        !userPrograms.wf_adminFirst_afUserProgram?.edges?.find(
            (item) => item.node.afProgram?.programName === "Video Management"
        )
    ) {
        return <NoPermission />;
    }
    return (
        <>
            <ContentTitle
                title={categoryList.find((v) => v.value === category)?.title || ""}
            />
            <Tabs
                defaultActiveKey="1"
                items={items}
                size="small"
                tabBarStyle={{
                    paddingLeft: 24,
                    backgroundColor: Colors.white,
                    height: 50,
                }}
            />
        </>
    );
};

export default TrialModeServiceTemplate;
